<script setup>
// NOTICE: KAPTION-INTEGRATION
// Sales Kanban entry point (mounted by ChatList on the kanban route).
// KAPTION_SALES_PIPELINE off → the classic funnel board, byte-for-byte as before.
// KAPTION_SALES_PIPELINE on  → the configurable Sales Pipeline board (which itself
// falls back to the classic board until an admin configures a pipeline).

import { computed } from 'vue';
import { useKaptionFeatureFlags } from 'dashboard/composables/useKaptionFeatureFlags';
import KaptionSalesKanbanClassic from './KaptionSalesKanbanClassic.vue';
import KaptionSalesPipelineBoard from './KaptionSalesPipelineBoard.vue';

defineProps({
  isDarkMode: { type: Boolean, default: false },
  // The chat list header's selection; only the pipeline board uses it.
  listScope: { type: Object, default: () => ({}) },
});

const { isKaptionFlagEnabled } = useKaptionFeatureFlags();
const pipelineEnabled = computed(() =>
  isKaptionFlagEnabled('KAPTION_SALES_PIPELINE')
);
</script>

<template>
  <KaptionSalesPipelineBoard
    v-if="pipelineEnabled"
    :is-dark-mode="isDarkMode"
    :list-scope="listScope"
  />
  <KaptionSalesKanbanClassic v-else :is-dark-mode="isDarkMode" />
</template>
